// extracted by mini-css-extract-plugin
export default {"section":"AppPreview_section__htkQ8","frame":"AppPreview_frame__onSSv"};